import React from "react";
import { DatePicker } from "antd";
import { Wrapper } from "./style";
import Label from "../style";
import moment from "moment";

export default ({ onChange, label, status, value, ...rest }) => {
  const handleDateChange = (date, dateString) => {
    onChange(dateString);
  };

  const formattedValue = value ? moment(value, "YYYY-MM-DD") : null;

  return (
    <Wrapper {...rest}>
      <div>
        <Label title={label} />
      </div>
      <DatePicker
        value={formattedValue}
        onChange={handleDateChange}
        format="YYYY-MM-DD"
        placeholder=""
        status={status}
      />
    </Wrapper>
  );
};
